import {
  DifficultList,
  DifficultTypes,
  DurationList,
  DurationTypes,
} from 'shared/constants/excursions'

export const getDifficultValue = (type: DifficultTypes) => {
  return DifficultList.find((list) => list.key === type)?.title!
}
export const getDurationValue = (type: DurationTypes) => {
  return DurationList.find((list) => list.key === type)?.title!
}
